import { render, staticRenderFns } from "./advent.vue?vue&type=template&id=06d3bf23&scoped=true&"
import script from "./advent.vue?vue&type=script&lang=js&"
export * from "./advent.vue?vue&type=script&lang=js&"
import style0 from "./advent.vue?vue&type=style&index=0&id=06d3bf23&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d3bf23",
  null
  
)

export default component.exports